module.exports = __webpack_public_path__ + "static/media/remidio.f4281a07.svg";